import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { PREFIX_BS } from '../config';
import DOffcanvasHeader from './components/DOffcanvasHeader';
import DOffcanvasBody from './components/DOffcanvasBody';
import DOffcanvasFooter from './components/DOffcanvasFooter';
const variants = {
    hidden: (openFrom) => {
        const properties = {};
        if (openFrom === 'start') {
            properties.x = '-100%';
        }
        if (openFrom === 'end') {
            properties.x = '100%';
        }
        if (openFrom === 'top') {
            properties.y = '-100%';
        }
        if (openFrom === 'bottom') {
            properties.y = '100%';
        }
        return properties;
    },
    visible: {
        x: 0,
        y: 0,
    },
};
const defaultTransition = {
    ease: 'easeInOut',
    duration: 0.3,
};
function DOffcanvas({ name, className, style, staticBackdrop, scrollable, openFrom = 'end', transition, children, dataAttributes, }) {
    return (_jsx(motion.div, Object.assign({ className: classNames('offcanvas portal show', {
            [`offcanvas-${openFrom}`]: openFrom,
        }, className), style: Object.assign(Object.assign({}, style), { transition: 'none' }), id: name, tabIndex: -1, "aria-labelledby": `${name}Label`, "aria-hidden": "false", custom: openFrom, variants: variants, initial: "hidden", animate: "visible", exit: "hidden", transition: Object.assign(Object.assign({}, (transition !== null && transition !== void 0 ? transition : defaultTransition)), { delay: 0.15 }) }, staticBackdrop && ({
        [`data-${PREFIX_BS}backdrop`]: 'static',
        [`data-${PREFIX_BS}keyboard`]: 'false',
    }), scrollable && ({
        [`data-${PREFIX_BS}scroll`]: 'true',
        [`data-${PREFIX_BS}keyboard`]: 'false',
    }), dataAttributes, { children: children })));
}
export default Object.assign(DOffcanvas, {
    Header: DOffcanvasHeader,
    Body: DOffcanvasBody,
    Footer: DOffcanvasFooter,
});
//# sourceMappingURL=DOffcanvas.js.map